import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import axios from "axios";
import HorizontalBar from "../components/HorizontalBar";

const DashboardSportmex = ({ loggedstate }) => {
    const [data, setData] = useState(null);
    const [exporting, setExporting] = useState(false);
    const [exportProgress, setExportProgress] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { clienteid, encuesta } = loggedstate.vars || {};
                const formData = new FormData();
                formData.append('cliente', clienteid || '');
                formData.append('encuesta', encuesta || '');

                const response = await axios.post(
                    process.env.REACT_APP_URL + 'dashboardSportmex.php?limitefecha=false',
                    formData,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );

                setData(response.data);
            } catch (err) {
                console.error('Error fetching dashboard data:', err);
                setData(null);
            }
        };

        fetchData();
    }, [loggedstate.vars]);

    const startExport = async () => {
        const { clienteid, encuesta } = loggedstate.vars || {};
        setExporting(true);
        setExportProgress(0);
        try {
            // primero comprobamos si el backend soporta xlsx (solo al click)
            let useXlsx = false;
            try {
                const chk = await axios.get(process.env.REACT_APP_URL + 'export_levantamientos.php?check=1');
                useXlsx = Boolean(chk.data && chk.data.phpspreadsheet);
            } catch (e) {
                useXlsx = false;
            }

            // se usa POST para respetar filtros que use el backend
            const formData = new FormData();
            formData.append('cliente', clienteid || '');
            formData.append('encuesta', encuesta || '');

            const resp = await axios.post(process.env.REACT_APP_URL + 'export_levantamientos.php' + (useXlsx ? '?mode=xlsx' : ''), formData, {
                responseType: 'blob',
                onDownloadProgress: (progressEvent) => {
                    if (progressEvent.lengthComputable) {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setExportProgress(percentCompleted);
                    } else {
                        // no computable size; mostrar indicador indeterminado
                        setExportProgress(50);
                    }
                }
            });

            // disparar descarga
            const blob = new Blob([resp.data], { type: resp.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            // intentar obtener filename del header
            const cd = resp.headers['content-disposition'];
            let filename = 'export';
            if (cd) {
                const m = cd.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/);
                if (m) filename = decodeURIComponent(m[1] || m[2]);
            }
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Error exporting:', err);
            alert('Error al generar exportación. Revisa la consola.');
        } finally {
            setExporting(false);
            setExportProgress(0);
        }
    };

    if (!data) return <div>Cargando</div>;

    const { numencuestas = 0, calificaciones = [], calificacionesporformato = {}, formatos = [], preguntas = [], calificacionesporformato_labels = {}, calificacionesporformato_pct = {}, global_pct = null, encuestastop = [], encuestasbottom = [], cuestionariostop = [], cuestionariosbottom = [], comentarios = [] } = data;

    const displayGlobalPct = (global_pct !== null) ? (Number(global_pct).toFixed(2) + '%') : 'N/A';

    return (
        <>
            <div className="grid col4">
                <div className="general">
                    <div className="text">
                        <h2>{numencuestas}</h2>
                        <span>encuestas totales</span>
                    </div>
                </div>
                <div className="general">
                    <div className="text">
                        <h2>{displayGlobalPct}</h2>
                        <span>calificación promedio total</span>
                    </div>
                </div>
            </div>

            <div style={{ margin: '12px 0' }}>
                <button className="export-button" onClick={() => startExport()} disabled={exporting}>{exporting ? 'Preparando...' : 'Descargar Excel'}</button>
                {exporting && (
                    <div style={{ marginTop: 8 }}>
                        <div className="export-progress" role="progressbar" aria-valuenow={exportProgress} aria-valuemin={0} aria-valuemax={100}>
                            <div className="bar" style={{ width: `${exportProgress}%` }} />
                        </div>
                        <div className="label">Progreso: {exportProgress}%</div>
                    </div>
                )}
            </div>

            <h2>Preguntas por formato</h2>
            {Object.entries(calificacionesporformato).map(([topKey, nestedObject]) => (
                <div key={topKey}>
                    <h2>{(topKey !== 'ecomerce') ? formatos[topKey] : 'Ecommerce'}</h2>
                    <HorizontalBar preguntas={preguntas} calificaciones={calificacionesporformato_pct[topKey] || {}} labels={calificacionesporformato_labels[topKey] || {}} />
                </div>
            ))}

            <h2>Calificaciones por pregunta (escala 0-10)</h2>
            <ul className="calificaciones-list">
                {Object.entries(calificaciones).map(([pid, val]) => (
                    <li key={pid}>{(preguntas[pid] || (pid === '0' ? 'Global' : pid))}: {Number(val).toFixed(2)}</li>
                ))}
            </ul>

            <div className="grid">
                <div>
                    <h3>Top por número de encuestas</h3>
                    <ul>
                        {encuestastop.map((e, i) => (<li key={i}>{e.nombre} — {e.encuestas}</li>))}
                    </ul>
                </div>
                {/*<div>
                    <h3>Bottom por número de encuestas</h3>
                    <ul>
                        {encuestasbottom.map((e, i) => (<li key={i}>{e.nombre} — {e.encuestas}</li>))}
                    </ul>
                </div>*/}
                <div>
                    <h3>Top por calificación</h3>
                    <ul>
                        {cuestionariostop.map((e, i) => (<li key={i}>{e.nombre} — {e.calificacion}</li>))}
                    </ul>
                </div>
                {/*<div>
                    <h3>Bottom por calificación</h3>
                    <ul>
                        {cuestionariosbottom.map((e, i) => (<li key={i}>{e.nombre} — {e.calificacion}</li>))}
                    </ul>
                </div>*/}
            </div>

            <h3>Comentarios ({comentarios.length})</h3>
            {comentarios.length > 0 ? (
                <ul>
                    {comentarios.map((c, i) => (<li key={i}>{c}</li>))}
                </ul>
            ) : (
                <p>No hay comentarios.</p>
            )}
        </>
    );
};

const mapStateToProps = state => ({ loggedstate: state });

export default connect(mapStateToProps)(DashboardSportmex);